import React from 'react';
import Card from 'common/card/Card';
import IconAmenityMobile from '@spothero/icons/amenity-mobile';
import IconCheckCircle from '@spothero/icons/check-circle';
import IconSearch from '@spothero/icons/search';

const CONTENT = [
    {
        title: 'Look',
        icon: IconSearch,
        description: 'Compare the best prices on parking near your airport.',
    },
    {
        title: 'Book',
        icon: IconCheckCircle,
        description: 'Book & pay online ahead of time to reserve your spot.',
    },
    {
        title: 'Park',
        icon: IconAmenityMobile,
        description: 'Scan or show your parking pass when you arrive.',
    },
];

const HowToBook = () => (
    <Card className="HowToBook">
        <div className="HowToBook-heading">
            <h2 className="HowToBook-title">How SpotHero Works</h2>
        </div>
        <div className="HowToBook-content">
            <ul className="HowToBook-items">
                {CONTENT.map(({description, icon: Icon, title}) => (
                    <li className="HowToBook-item" key={title}>
                        <div className="HowToBook-icon">
                            <Icon />
                        </div>
                        <div className="HowToBook-item-text">
                            <span className="HowToBook-label">{title}</span>
                            <span className="HowToBook-description">
                                {description}
                            </span>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    </Card>
);

export default HowToBook;
